import React from 'react';
import { withSnackbar } from 'notistack';
import useUpdateHoldStatus from './useUpdateHoldStatus';
import CustomConfirmationDialog from '../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';

const DeleteFromHoldList = ({
  selectedData,
  label,
  onCancel,
  updateHoldData,
  enqueueSnackbar,
  gridName
}) => {
  const updateHoldStatus = useUpdateHoldStatus();

  const handleDeleteHoldDataError = (response) => {
    onCancel();
    const statusCode = response?.status || response;
    if (statusCode === 403) return;
    enqueueSnackbar(`Error while deleting ${selectedData} ${gridName} from hold list`, {
      variant: 'error'
    });
  };

  const onConfirmDelete = () => {
    updateHoldStatus({
      params: { [label]: selectedData, isOnHold: false },
      methods: {
        onSuccess: () => {
          onCancel();
          enqueueSnackbar(`${selectedData} ${gridName} removed from hold list successfully`, {
            variant: 'success'
          });
          updateHoldData();
        },
        onError: (response) => {
          handleDeleteHoldDataError(response);
        }
      }
    });
  };

  return (
    <CustomConfirmationDialog
      title={`Remove ${gridName} from Hold List`}
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Delete"
      mode="danger"
      onConfirm={onConfirmDelete}
      onCancel={onCancel}>
      <div>{`Removing selected ${gridName} from the hold list would clear their on-hold status and allow them to be included in routing. Do you want to continue?`}</div>
    </CustomConfirmationDialog>
  );
};

export default withSnackbar(DeleteFromHoldList);
